import { Routes } from '@angular/router';

export const Approutes: Routes = [
  {
    path: '',
    loadChildren: './admin/admin.module#AdminModule',
  }
];
